@if (initialized) {
<!--    DONE-->
<!--    <p-tabView [(activeIndex)]="activeIndex">-->
<!--        @for (tab of tabConfigs; track tab.header) {-->
<!--            <p-tabPanel [header]="tab.header" [leftIcon]="tab.icon"></p-tabPanel>-->
<!--        }-->
<!--    </p-tabView>-->
    <p-tabs [(value)]="activeIndex" >
        <p-tablist>
            @for (tab of tabConfigs; track $index) {
                <p-tab [value]="$index">
                    <i [class]="tab.icon" class="mr-2"></i>
                    {{ tab.header }}
                </p-tab>
            }
        </p-tablist>
    </p-tabs>

    @if (tabConfigs[activeIndex].data) {
        <mvs-widget
                [widgetData]="tabConfigs[activeIndex].data"
                (onObjectSelect)="handleObjectSelect($event)"
        ></mvs-widget>
    }
}
